import moment from "moment";

// src/config/filterConfig.js
// const filterConfig = {
//     '/center-daily-report': {
//         showSelect: true, showDateRange: {
//             show: true, type: 'montyh', label: 'Date', placeholder: 'Select Date'
//         }
//     },
//     '/doctor_revenue': { showSelect: false, showDateRange: true },
//     '/analytics': { showSelect: false, showDateRange: true },
//     // Add more routes as needed
// };
// 🧠 Generate month ranges up to the current month - 1
function generatePreviousMonthRanges() {
    const now = moment();
    const year = now.year();
    const currentMonth = now.month(); // 0-indexed (0 = Jan)

    const ranges = {};

    for (let m = 0; m < currentMonth; m++) {
        const start = moment({ year, month: m, day: 1 }).startOf("month");
        const end = moment({ year, month: m, day: 1 }).endOf("month");
        const label = start.format("MMMM YYYY"); // e.g., "February 2025"

        // ✅ These are full dates like "2025-02-01" to "2025-02-28"
        ranges[label] = [start, end];
    }

    return ranges;
}
const filterConfig = {
    '/center-state-overview': {

        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: { format: 'YYYY-MM-DD' },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: true,
            // ranges: {
            //     'Last Day': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            //     'Last 30 Days': [moment().subtract(30, 'days'), moment()],
            // },
            ranges: {
                'Last Day': [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days')
                ],

                'Month Till Date': [
                    moment().startOf('month'),
                    moment()
                ],

                'Last Month': [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month')
                ],

                'Last Year': [
                    moment().subtract(1, 'month').startOf('month').subtract(1, 'year'),
                    moment().subtract(1, 'month').endOf('month')
                ],
            }
        },

    },
    '/center-group-overview': {

        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: { format: 'YYYY-MM-DD' },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: true,
            // ranges: {
            //     'Last Day': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            //     'Last 30 Days': [moment().subtract(30, 'days'), moment()],
            // },
            ranges: {
                'Last Day': [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days')
                ],

                'Month Till Date': [
                    moment().startOf('month'),
                    moment()
                ],

                'Last Month': [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month')
                ],

                'Last Year': [
                    moment().subtract(1, 'month').startOf('month').subtract(1, 'year'),
                    moment().subtract(1, 'month').endOf('month')
                ],
            }
        },

    },
    '/center-daily-report': {
        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: { format: 'YYYY-MM-DD' },
            ranges: {
                Today: [moment(), moment()],
                'Last 15 Days': [moment().subtract(14, 'days'), moment()],
            },
        },
    },
    '/doctor_revenue': {
        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: {
                format: 'YYYY-MM-DD',
            },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            ranges: generatePreviousMonthRanges(), // ✅ dynamic
        },
    },
    '/doctors_revenue': {

        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: { format: 'YYYY-MM-DD' },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: true,
            // ranges: {
            //     'Last Day': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            //     'Last 30 Days': [moment().subtract(30, 'days'), moment()],
            // },
            ranges: {
                'Last Day': [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days')
                ],

                'Month Till Date': [
                    moment().startOf('month'),
                    moment()
                ],

                'Last Month': [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month')
                ],

                'Last Year': [
                    moment().subtract(1, 'month').startOf('month').subtract(1, 'year'),
                    moment().subtract(1, 'month').endOf('month')
                ],
            }
        },

    },

    '/center-report': {
        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: {
                format: 'YYYY-MM-DD',
            },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            ranges: generatePreviousMonthRanges(), // ✅ dynamic
        },
    },
    '/center-treatment-overview': {

        showSelect: true,
        showDateRange: true,
        dateRangeConfig: {
            locale: { format: 'YYYY-MM-DD' },
            singleDatePicker: false,
            showDropdowns: true,
            autoApply: true,
            alwaysShowCalendars: true,
            showCustomRangeLabel: true,
            ranges: {
                'Last Day': [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days')
                ],

                'Month Till Date': [
                    moment().startOf('month'),
                    moment()
                ],

                'Last Month': [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month')
                ],

                'Last Year': [
                    moment().subtract(1, 'month').startOf('month').subtract(1, 'year'),
                    moment().subtract(1, 'month').endOf('month')
                ],
            }
        },

    },
};
export default filterConfig;

